module.exports = __webpack_public_path__ + "img/login-banner-logo.5566c33c.png";